var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitzerland({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 1.55172C22.3139 1.55219 22.6743 1.68544 22.9401 1.92223C23.2059 2.15902 23.3555 2.48005 23.356 2.81493V20.521C23.3555 20.8559 23.2059 21.1769 22.9401 21.4137C22.6743 21.6505 22.3139 21.7838 21.938 21.7843H2.06201C1.6861 21.7838 1.32572 21.6505 1.05991 21.4137C0.7941 21.1769 0.644523 20.8559 0.643994 20.521V2.81493C0.644523 2.48005 0.7941 2.15902 1.05991 1.92223C1.32572 1.68544 1.6861 1.55219 2.06201 1.55172H21.938ZM21.938 0.978027H2.06201C1.5153 0.978499 0.991126 1.17219 0.604541 1.51657C0.217956 1.86095 0.000529505 2.3279 0 2.81493V20.521C0.000529505 21.0081 0.217956 21.475 0.604541 21.8194C0.991126 22.1638 1.5153 22.3575 2.06201 22.3579H21.938C22.4845 22.357 23.0084 22.1632 23.3949 21.8189C23.7813 21.4746 23.9989 21.0079 24 20.521V2.81493C23.9995 2.3279 23.782 1.86095 23.3955 1.51657C23.0089 1.17219 22.4847 0.978499 21.938 0.978027Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9379 1.55176H2.06197C1.68605 1.55223 1.32568 1.68548 1.05987 1.92227C0.794057 2.15906 0.644481 2.48009 0.643951 2.81497V20.5211C0.644481 20.856 0.794057 21.177 1.05987 21.4138C1.32568 21.6506 1.68605 21.7838 2.06197 21.7843H21.9379C22.3139 21.7838 22.6742 21.6506 22.94 21.4138C23.2059 21.177 23.3554 20.856 23.356 20.5211V2.81497C23.3554 2.48009 23.2059 2.15906 22.94 1.92227C22.6742 1.68548 22.3139 1.55223 21.9379 1.55176ZM19.506 13.667H14.252V18.3475H9.74796V13.667H4.49395V9.65474H9.74796V4.97432H14.252V9.65474H19.506V13.667Z",
    fill: "#E5340F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.252 4.97412H9.74796V9.65454H4.49396V13.6651H9.74796V18.3455H14.252V13.6651H19.506V9.65454H14.252V4.97412Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.978027)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitzerland);
export default __webpack_public_path__ + "static/media/Switzerland.e3bdf494ec66ea5239e59c0cb1080b70.svg";
export { ForwardRef as ReactComponent };